module.exports = "/images/icloud.png?0d61f143ea8bc4130730d88346152e2a";